import { render, staticRenderFns } from "./TimeBadge.vue?vue&type=template&id=2e382276&scoped=true"
import script from "./TimeBadge.vue?vue&type=script&lang=ts"
export * from "./TimeBadge.vue?vue&type=script&lang=ts"
import style0 from "./TimeBadge.vue?vue&type=style&index=0&id=2e382276&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e382276",
  null
  
)

export default component.exports